import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const TrendText = styled('span')(({ theme }) => ({
  color: theme.palette.grey[600],
  fontWeight: 400,
  marginLeft: theme.spacing(0.5),
  fontSize: '0.875rem',
}))

export const ProjectionWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: theme.spacing(1),
  fontSize: '0.875rem',
  color: theme.palette.grey[600],
  paddingTop: theme.spacing(1),
  borderTop: `1px solid ${theme.palette.divider}`
}))

export const ProjectionLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
  fontWeight: 400,
}))

export const ProjectionValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[800],
  fontWeight: theme.typography.fontWeightMedium,
}))
